var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 11.2745L3.51869 17.7558C3.35306 17.9251 3.12396 18.0172 2.88725 18.0095C2.65245 18.0074 2.42785 17.9128 2.26205 17.7467C2.09624 17.5803 2.00253 17.3554 2.00097 17.1206C1.99942 16.8858 2.09036 16.6596 2.2541 16.4912L8.7354 10.0099L2.2541 3.52862C2.08483 3.36298 1.99268 3.13389 2.00046 2.89718C1.9951 2.66048 2.08673 2.43172 2.25427 2.26419C2.42181 2.09666 2.65055 2.00501 2.88726 2.01037C3.12396 2.00259 3.35303 2.09474 3.51871 2.26401L10 8.74531L16.4813 2.26401C16.648 2.09527 16.875 2.00017 17.1122 2C17.3493 1.99983 17.5766 2.09475 17.7433 2.26332C17.91 2.4319 18.0023 2.66012 17.9995 2.89716C18.0073 3.13386 17.9152 3.36293 17.7459 3.5286L11.2646 10.0099L17.7459 16.4912C17.9594 16.7196 18.0383 17.0426 17.9539 17.3436C17.8697 17.6444 17.6346 17.8796 17.3337 17.9638C17.0327 18.0482 16.7097 17.9693 16.4813 17.7558L9.99999 11.2745Z",
    fill: "#7E8BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7f5ab76669ba470723277cb6d4a1ca73.svg";
export { ForwardRef as ReactComponent };